<template>
  <div class="affix">
    <el-form :model="item" status-icon ref="ruleForm" :label-width="labelWidth" class="demo-ruleForm">
       <el-form-item :label="name" prop="pass">
         <span slot="label" :title="name" :alt="name" class="label-wrap">
           <i v-show="item.required" style="color: red">*</i>
            {{ name ? ( name + '：') : '附件信息：' }}
        </span>
         <template v-if="item.attFiles">
           <template v-if="item.attFiles.length > 0">
             <div v-for="(f,idx) in item.attFiles" :key="f.filePath" style="position: relative;">
               <p>{{f.name}}</p>
               <label class="upload">
                 <em class="el-icon-upload2" v-if="idx == 0" @click="uploadBtn($event)"></em>
                 <em  v-show="f.filePath" class="el-icon-view" @click="fileView(f)"></em>
                 <em  v-show="f.filePath" class="el-icon-download" @click="fileDownload(f)"></em>
                 <em class="el-icon-delete" @click="delMent(f,idx)"></em>
               </label>
             </div>
           </template>
           <template v-else>
             <p>
               <label class="upload" @click="uploadBtn($event)">
                 <em class="el-icon-upload2"></em>
               </label>
             </p>
           </template>
         </template>
         <template v-else>
           <p >{{item.name}}</p>
           <label class="upload" @click="uploadBtn($event)">
             <em class="el-icon-upload2"></em>
           </label>
           <label class="upload">
             <em class="el-icon-delete" @click="delMent(item)"></em>
           </label>
         </template>
      </el-form-item>
      <upload ref="uploadComRef" :accept-file-type="allows" @uploadSuccess="uploadSuccess"></upload>
    </el-form>
    <el-dialog :visible.sync="imgDialogVisible" :modal="showModal" width="100%" height="100%" @closed="dialogClose">
      <img :src="filePath" alt="" @contextmenu.prevent=""  class="viewImg">
    </el-dialog>
  </div>
</template>

<script>
  import $ from "jquery";
  import upload from "@/components/affixMsg/upload";
  export default {
    components:{
      upload
    },
    data() {
      return {
        attachmentId: 'attachment' + new Date().getTime(),
        pdfViewer:'/pdf/web/viewer.html?file=',
        imgDialogVisible:false,
        dialogImageUrl:'',
        filePath:'',
        url:''
      }
    },
    props: {
      index: {
        type: Number,
        required: true
      },
      labelWidth: {
        type: String,
        default:"180px"
      },
      item: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      showModal: {
        type: Boolean,
        default:true,
      },
      type: {
        type: String,
        required: true
      }
    },
    computed:{
      allows:{
        get:function(){
          if(this.item.allows.indexOf('.') == 0){
            return this.item.allows;
          }else{
            let allows = '.' + this.item.allows
            return (allows.split(',')).join(',.');
          }
        },
      }
    },
    mounted() {
      this.pdfViewer = this.$http.adornUrl(this.pdfViewer);
    },
    methods: {
      delMent(item,index){
        if(index !== undefined){
          this.item.attFiles.splice(index, 1)
        }else{
          delete item.bizId;
          delete item.createDate;
          delete item.delFlag;
          delete item.hashCode;
          delete item.id;
          delete item.updateBy;
          delete item.updateDate;
          item.extendName='';
          item.filePath='';
          item.name='';
        }
      },
      uploadSuccess(res){
        if(this.item.attFiles === undefined){
          this.item.filePath = res.data.filepath;
          this.item.name = res.data.name;
          this.item.extendName = res.data.extendName;
        }else{
          this.item.attFiles.push({
            ...res,
            sysAttachmentDataId:this.item.sysAttachmentDataId,
            name:res.fileName,
            fileType:this.item.fileType
          })
        }

      },
      docXia(){ //详情
        this.$http({
          method:'post',
          url:`/attachment/download?id=${this.item.id}`,
          responseType:'blob'
        }).then(res => {
          let blob = new Blob([res.data],{type:'application/pdf'})
          this.url = window.URL.createObjectURL(blob);
        })
      },
      dialogClose() {
        this.dialogImageUrl = "";
        this.imgDialogVisible = false;
      },
      isAssetTypeAnImage(ext){
        let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
        return arr.indexOf(ext.toLowerCase()) !== -1;
      },
      isAssetTypeAnPDF(ext) {
        let arr = ['pdf', 'PDF']
        return arr.indexOf(ext.toLowerCase()) !== -1;
      },
      fileView(item){
        // 获取文件类型
        let type = item.name.substr(item.name.lastIndexOf(".")+1);
        let imgFlag = this.isAssetTypeAnImage(type);
        let pdfFlag = this.isAssetTypeAnPDF(type);
        if(pdfFlag){
          window.open(this.pdfViewer + item.filePath, '_blank');
          return
        }
        if(imgFlag){
          this.filePath = item.filePath;
          this.imgDialogVisible = true;
        }else{
          this.fileDownload(item);
        }
      },
      fileDownload(item){
        if(item.filePath ){
          if(item.bizId){
            this.$http({
              method:'get',
              url:`/attachment/downloadFile?businessId=${item.bizId}&fileType=${item.fileType}&id=${item.id}`,
            }).then(res => {
              if(res.data.code==='1'){
                var a = document.createElement('a');
                a.download = this.item.name;
                a.target="_Blank";
                a.href = res.data.data;
                $("body").append(a);
                a.click();
                $(a).remove();
              }else{

                this.$message({
                  type:'error',
                  message:res.data.msg
                })
              }
            })
          }else{
            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(item.filePath));
            element.setAttribute('download', item.name);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);

          }

        }
      },
      uploadBtn(e) {
        this.$refs.uploadComRef.selectFileClick();
      },
    },
    watch:{
      item(val){
        this.$emit('update:item',val)
      }
    }
  }
</script>

<style scoped>
  .affix p{
    text-overflow: ellipsis;
    word-break: break-word;
    white-space: nowrap;
    overflow: hidden;
  }
  em{
    cursor: pointer;
  }
  .affix .upload{
    background-color: #FFF;
    right:0px !important;
  }
  .affix .upload em{
    margin-left: 8px;
  }
</style>
